/**
 * Ajax function to grab gallery set images and put in modal.
 * @param  {INT} post_id
 * @param  {INT} gallery_id
 * @return {String}            The gallery
 */
function wu_get_gallery_set_images(gallery_title, post_id, gallery) {
    $('body').append('<div class="modal fade" id="modal-' + gallery_title + '"><a href="#" class="modal__close"><span class="burger"></span></a><div class="modal__gallery"></div></div>');
    $('#modal-' + gallery_title).modal('show').on('hidden.bs.modal', function (e) {
      $(this).remove();
    });

    // why ajax??
    // 
    // var data = {
    //     'action': 'wu_get_gallery',
    //     'post_id': post_id,
    //     'gallery_id': gallery_id
    // };
    // console.log(post_id);
    // console.log(gallery_id);
    // $.post(ajax_login_object.ajaxurl, data, function(response) {
    //     $('.modal__gallery').append(response);
    //     $('.modal__gallery__images').slick({
    //         prevArrow: '<a href="#" class="previous" aria-label="Previous"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
    //         nextArrow: '<a href="#" class="next" aria-label="Next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
    //         dots: false,
    //         infinite: true,
    //         speed: 1300,
    //         variableWidth: true,
    //         lazyLoad: 'progressive',
    //     });
    // });
    // 

    $('.modal__gallery').append(gallery);

    setTimeout(function(){
        $('.modal__gallery .modal__gallery__images').slick({
            prevArrow: '<a href="#" class="previous" aria-label="Previous"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
            nextArrow: '<a href="#" class="next" aria-label="Next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
            dots: false,
            infinite: true,
            speed: 1300,
            initialSlide: 0,
            variableWidth: true,
            lazyLoad: 'progressive'
        }).slick('slickGoTo', 0);
     
    }, 10);

    $(document).on('click', '.modal__close', function(event) {
        event.preventDefault();
        $('#modal-' + gallery_title).modal('hide');
    });
}

$(document).on('click', '.gallery__set__link', function(event) {
    event.preventDefault();
    var gallery_title = $(this).attr('href').replace('#', ''),
        post_id = parseInt($(this).attr('data-page-id')),
        gallery = $(this).next().find('.modal__gallery__images').clone();
    wu_get_gallery_set_images(gallery_title, post_id, gallery);
});
